/** Public booking rules mirrored by the Tours edge validation. */
export const MIN_TOUR_PASSENGERS = 10
export const MIN_TOUR_BOOKING_DAYS_AHEAD = 2
export const TOUR_BOOKING_TIME_ZONE = 'America/El_Salvador'

function tourDateISO(value: Date): string {
  try {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-US', {
        timeZone: TOUR_BOOKING_TIME_ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
        .formatToParts(value)
        .map((part) => [part.type, part.value]),
    )
    if (parts.year && parts.month && parts.day) {
      return `${parts.year}-${parts.month}-${parts.day}`
    }
  } catch {
    // El Salvador has no daylight-saving transitions; fixed UTC-06 is a safe
    // fallback for old Android Intl builds without IANA timezone data.
  }
  return new Date(value.getTime() - 6 * 60 * 60 * 1000).toISOString().slice(0, 10)
}

function addCalendarDaysISO(dateISO: string, days: number): string {
  const [year, month, day] = dateISO.split('-').map(Number)
  return new Date(Date.UTC(year!, month! - 1, day! + days)).toISOString().slice(0, 10)
}

/**
 * First bookable civil date in El Salvador.
 *
 * Two calendar dates ahead leaves one complete day between booking and tour:
 * a booking made at any time on the 14th can start at any time on the 16th.
 */
export function earliestTourBookingDateISO(now: Date = new Date()): string {
  return addCalendarDaysISO(tourDateISO(now), MIN_TOUR_BOOKING_DAYS_AHEAD)
}

export function isTourBookingDateAllowed(dateISO: string, now: Date = new Date()): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(dateISO) && dateISO >= earliestTourBookingDateISO(now)
}
